// ============================================
// Path: /frontend/src/components/CategoryToggle.jsx
// Purpose: Toggle switch to navigate between Properties and Vehicles pages
// ============================================

import { useNavigate, useLocation } from 'react-router-dom';

export const CategoryToggle = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const isVehicles = location.pathname === '/vehicles';
  const isProperties = location.pathname === '/properties';

  // Only show on properties or vehicles pages
  if (!isVehicles && !isProperties) return null;

  return (
    <div className="flex items-center gap-2 mb-6">
      <button
        onClick={() => navigate('/properties')}
        className={`w-28 px-3 py-1.5 rounded-md transition-all text-center text-xs sm:text-sm ${
          isProperties
            ? 'bg-primary text-primary-foreground shadow-md'
            : 'bg-muted text-muted-foreground hover:bg-muted/80'
        }`}
      >
        <span className="font-medium">Properties</span>
      </button>

      <button
        onClick={() => navigate('/vehicles')}
        className={`w-28 px-3 py-1.5 rounded-md transition-all text-center text-xs sm:text-sm ${
          isVehicles
            ? 'bg-primary text-primary-foreground shadow-md'
            : 'bg-muted text-muted-foreground hover:bg-muted/80'
        }`}
      >
        <span className="font-medium">Vehicles</span>
      </button>
    </div>
  );
};